/* import __COLOCATED_TEMPLATE__ from './tabs.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();